import { environmentInfo } from '@ms-cloudpack/environment';
import type { LoginMethod } from '@ms-cloudpack/remote-cache';

export function getDefaultLogin(): LoginMethod {
  return environmentInfo.isCI ? 'azure-cli' : environmentInfo.isCodespaces ? 'device-code' : 'interactive';
}
